import React, { FC, HTMLAttributes } from "react";
import styled from "styled-components";
import { ProjectServiceType } from "interfaces/front/business";
import ServiceTypeBadge from "../layout/ServiceTypeBadge";

const TitleSection: FC<HTMLAttributes<HTMLDivElement> & { projectCode: string; serviceType: ProjectServiceType; title: string; summary: string }> = ({
  projectCode,
  serviceType,
  title,
  summary,
  ...props
}) => {
  const isSupernova = projectCode === "supernova";
  return (
    <Root {...props}>
      {!isSupernova && <StyledServiceTypeBadge serviceType={serviceType} />}
      {!isSupernova ? <Title>{title}</Title> : <Title2>{title}</Title2>}
      <Summary dangerouslySetInnerHTML={{ __html: summary.replace(/\n/g, "<br />") }} />
    </Root>
  );
};
export default TitleSection;

const Root = styled.section``;
const StyledServiceTypeBadge = styled(ServiceTypeBadge)`
  margin-bottom: 8px;
`;
const Title = styled.h1`
  color: #fff;
  font-style: italic;
  width: 100%;
  @media screen and (max-width: 960px) {
    font-size: 20px;
    margin-bottom: 18px;
    line-height: 1.4em;
  }
  @media screen and (min-width: 961px) {
    font-size: 28px;
    margin-bottom: 28px;
    line-height: 1.357em;
  }
`;
const Title2 = styled.h1`
  color: #fff;
  width: 100%;
  @media screen and (max-width: 960px) {
    font-size: 20px;
    margin-bottom: 18px;
    line-height: 1.4em;
  }
  @media screen and (min-width: 961px) {
    font-size: 28px;
    margin-bottom: 28px;
    line-height: 1.357em;
  }
`;
const Summary = styled.h2`
  color: #fff;
  line-height: 1.42em;
  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
  @media screen and (min-width: 961px) {
    font-size: 16px;
  }
`;
